import { render } from "./ConfigLiveDataPlant.vue?vue&type=template&id=5bfaca6d"
import script from "./ConfigLiveDataPlant.vue?vue&type=script&lang=js"
export * from "./ConfigLiveDataPlant.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__